import { put, post } from 'axios'
import { normalizeFakeEmail } from '@/helpers/mailFake'

const CONFIRM_ACCOUNT_ROUTE = 'accounts'

// initial state
function initialState() {
  return {
    confirmAccount: {
      form: {
        code: undefined,
        birthDate: undefined,
        password: undefined,
        token: undefined,
        googleRecaptcha: undefined,
        secretQuestion: undefined,
        secretQuestionAnswer: undefined,
      },
      message: undefined,
      submitInProgress: false,
    },
  }
}

function formatToSend(data) {
  const {
    birthDate,
    code,
    password,
    token,
    googleRecaptcha,
    secretQuestion = null,
    secretQuestionAnswer = null,
  } = data
  const dataItem = birthDate.split('/')
  return {
    code: code
      .trim()
      .replace(/\./g, '')
      .replace(/-/g, ''),
    birthDate: [dataItem[2], dataItem[1], dataItem[0]].join('-'),
    password,
    token,
    googleRecaptcha,
    ...(secretQuestion && { secretQuestion }),
    ...(secretQuestionAnswer && { secretQuestionAnswer }),
  }
}

const state = initialState()

// getters
const getters = {
  confirmAccount: state => state.confirmAccount,
}

// actions
const actions = {
  confirmAccount({ state }) {
    const dataFormated = formatToSend(state.confirmAccount.form)

    return put(CONFIRM_ACCOUNT_ROUTE, dataFormated).then(() => {
      const { code, password, googleRecaptcha } = state.confirmAccount.form
      const data = {
        email: normalizeFakeEmail(code),
        password,
        googleRecaptcha,
      }
      return post('/auth/login', data).then(response => {
        return response.data.token
      })
    })
  },

  updateMessage(state, message) {
    state.confirmAccount.message = message
  },

  clearPassword(state) {
    state.confirmAccount.form.password = undefined
  },

  // eslint-disable-next-line no-unused-vars
  reset({ state }) {
    state = initialState()
  },
}

const mutations = {
  updateConfirmAccountForm(state, properties) {
    state.confirmAccount.form[properties.property] = properties.value
  },
  updateMessage(state, message) {
    state.confirmAccount.message = message
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
